import { connect } from 'react-redux'
import { withMe } from 'pobble-components/dist/pobble-user'
import StudentAvatar from './student-avatar'
import {
  getUser,
  getUserAvatar,
  getUploadAvatarRequest
} from '../../../../stores/user/user.selectors'
import { updateStudentAvatar } from '../../../../stores/user/user.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const user = getUser(state)
  const userAvatar = getUserAvatar(state)
  const uploadAvatarRequest = getUploadAvatarRequest(state)
  return {
    id: user.id,
    pending: uploadAvatarRequest.pending,
    url: !userAvatar ? null : userAvatar.url,
    displayName: user.display_name,
    avatar: userAvatar
  }
}

const mapDispatchToProps = (dispatch, { refetchMe }) => ({
  onUpdate: (id, color, code) =>
    dispatch(updateStudentAvatar(id, color, code))
      .then(refetchMe)
      .catch(errorHandler)
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(StudentAvatar)
)
